export function getSubscribersForQueryId(store, id) {
    const query = store.getQueryByID(id);
    return query ? store.getConnectionsForQuery(query) : [];
}
//# sourceMappingURL=GetSubscribersForQueryId.js.map